
import api from "../api"
export default {
	async getConnections() {
		let value = await api.get(`/connections`, { params: { type: "mutual" } })
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}

		return value?.data?.data || []
	},
	async getAllConnections(name) {
		let value = await api.get(`/connectionsall`, { params: { name: name } })
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
	async getOnsiteConnections() {
		let value = await api.get(`/onsiteconnections`, { params: { type: "mutual" } })
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
	async getIncomingConnections() {
		let value = await api.get(`/connections`, { params: { type: "incoming" } })
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
	async getOutgoingConnections() {
		let value = await api.get(`/connections`, { params: { type: "outgoing" } })
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
	async deleteConnection(id) {
		if (isNaN(parseInt(id))) {
			throw Error("ID must be a number")
		}
		let value = await api.delete(`/connections/${id}`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return true
	},
	/**
     * Adds a new connection
     * @param {number} clientID
     */
	async addConnection(clientID) {
		let cid = parseInt(clientID)
		if (isNaN(cid)) {
			throw new Error("Client ID must be a number")
		}
		let value = await api.put(`/connections/${cid}`)
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	/**
     * Gets information about a connection
     * @param {number} clientID 
     */
	async getConnectionInformation(clientID) {
		let cid = parseInt(clientID)
		if (isNaN(cid)) {
			throw new Error("Client ID must be a number")
		}
		let value = await api.get(`/connections/${cid}`)
		if (!value || !value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let _clientID = value.data.data[0].clientID
		let _name = value.data.data[0].name
		let logoURL = value.data.data[0].logoURL
		let statuses = {
			0: "none",
			1: "incoming",
			2: "outgoing",
			3: "mutual"
		}
		let status = statuses[value.data.data[0].status]
		return {
			clientID: _clientID,
			name: _name,
			status: status,
			logoURL,
			canManageSupplierPerformance: value.data.data[0].canManageSupplierPerformance === true,
		}
	},
	async getContract(clientID) {
		const cid = parseInt(clientID)
		if (isNaN(cid)) {
			throw new Error("Client ID must be a number")
		}
		const value = await api.get(`/connections/${cid}/contract`)
		if (!value || !value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			const error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return {
			contracts: value.data.data || [],
			totalCount: value.data.metadata?.pagination?.totalRecords ?? (value.data.data || []).length,
		}
	},
	async uploadContract(clientID, payload) {
		const cid = parseInt(clientID)
		if (isNaN(cid)) {
			throw new Error("Client ID must be a number")
		}
		const formData = new FormData()
		if (payload.file) {
			formData.append("file", payload.file)
			formData.append("filename", payload.file.name)
		}
		formData.append("contractName", payload.contractName)
		formData.append("contactName", payload.contactName)
		formData.append("pointOfContact", payload.pointOfContact)
		formData.append("expiryDate", payload.expiryDate)
		if (payload.replaceContractId) {
			formData.append("replaceContractId", payload.replaceContractId)
		}
		const value = await api.post(`/connections/${cid}/contract`, formData, {
			headers: {
				"content-type": "multipart/form-data",
			},
		})
		if (!value || !value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			const error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	async getKpiEvaluation(clientID) {
		const cid = parseInt(clientID)
		if (isNaN(cid)) {
			throw new Error("Client ID must be a number")
		}
		const value = await api.get(`/connections/${cid}/kpi-evaluation`)
		if (!value || !value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			const error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0] || null
	},
	async saveKpiEvaluation(clientID, payload) {
		const cid = parseInt(clientID)
		if (isNaN(cid)) {
			throw new Error("Client ID must be a number")
		}
		const value = await api.post(`/connections/${cid}/kpi-evaluation`, payload)
		if (!value || !value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			const error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	async getKpiEvaluationHistory(clientID) {
		const cid = parseInt(clientID)
		if (isNaN(cid)) {
			throw new Error("Client ID must be a number")
		}
		const value = await api.get(`/connections/${cid}/kpi-evaluation/history`)
		if (!value || !value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			const error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data || []
	},
	async getSharedKpiEvaluation(clientID) {
		const cid = parseInt(clientID)
		if (isNaN(cid)) {
			throw new Error("Client ID must be a number")
		}
		const value = await api.get(`/connections/${cid}/kpi-evaluation/shared`)
		if (!value || !value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			const error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0] || null
	},
	async getProjects() {
		let value = await api.get(`/api/projects`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0].Projects
	},
	async createProjects(newproject){
		if(!newproject){
			throw new Error("Project data is empty")
		}
		let value = await api.post(`/api/projects/`, {newproject})
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data
	},
	async deleteProject(id,name){
		let value = await api.delete(`/api/projects/${id}/${name}`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return true
	},
	async updateProject(id,name,clientsinvolved){
		let value = await api.patch(`/api/projects/${id}/${name}`,{clientsinvolved})
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return true
	},
	async getExistingConnections() {
		let value = await api.get(`/existingall`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
	async getExistingDetails() {
		let value = await api.get(`/getexisting`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
}